import { Col, Form, InputNumber } from "antd";
import { MazakaInputProps } from "models/Client/MazakaInputModel";
import { FC } from "react";
import { NumericFormat } from "react-number-format";

const MazakaInputNumber: FC<MazakaInputProps> = (props) => {
  const valueType: any = props.value;

  return (
    <>
      <Col
        className={props.colClassName}
        span={props.span}
        xs={props.xs}
        sm={props.sm}
        md={props.md}
        lg={props.lg}
        xl={props.xl}
        xxl={props.xxl}
      >
        <Form.Item
          className={props.className}
          name={props.name}
          initialValue={props.initialValue}
          rules={props.rules}
          label={props.label}
          colon={props.colon}
          labelAlign={props.labelAlign}
          labelCol={props.labelCol}
          wrapperCol={props.wrapperCol}
          hasFeedback={props.hasFeedback}
          tooltip={props.tooltip}
          noStyle={props.noStyle}
          help={props.help}
          validateStatus={props.validateStatus}
        >
          {props.formattedInputNumber ? (
            <>
              <NumericFormat
                className={`rounded !w-full !h-[30px] !border-[#d9d9d9"] focus:!border-[#d9d9d9"]  ${props.inputClassName} `}
                style={{
                  border: "1px solid #d9d9d9",
                  padding: "4px 11px",
                  fontSize: "14px",
                }}
                onChange={props.onChange}
                onBlur={props.onBlur}
                onValueChange={props.onInputNumberChange}
                pattern={props.pattern}
                disabled={props?.disabled}
                min={props.min}
                max={props.max}
                type="text"
                placeholder={props.placeholder}
                value={valueType}
                thousandSeparator="." // Use dot as thousands separator
                decimalSeparator="," // Use comma as decimal separator
                decimalScale={2} // Ensure two decimals
                fixedDecimalScale={true} // Ensure fixed decimals
              />
            </>
          ) : (
            <>
              <InputNumber
                className={`number rounded !w-full ${props.inputClassName}`}
                onBlur={props.onBlur}
                onChange={props.onInputNumberChange}
                prefix={props?.prefix}
                suffix={props?.suffix}
                pattern={props.pattern}
                disabled={props?.disabled}
                min={props.min}
                max={props.max}
                bordered={props.bordered}
                size={props.size}
                type={props?.type}
                placeholder={props.placeholder}
                addonAfter={props.addonAfter}
                addonBefore={props.addonBefore}
                value={valueType}
              />
            </>
          )}
        </Form.Item>
      </Col>
    </>
  );
};

export default MazakaInputNumber;
